import React from 'react';
import MetaTags from 'react-meta-tags';
import JsonLd from './JsonLd';
import PropTypes from 'prop-types';

const MetaComponent = props => (
  <MetaTags>
    <title>{ props.title }</title>
    {
      props.metas && props.metas.map((meta, key) => (
        <meta key={ key } name={ meta.name } content={ meta.content } />
      ))
    }
    {
      props.ogMetas.map((meta, key) => (
        <meta key={ key } property={ meta.property } content={ meta.content } />
      ))
    }
    <link rel="canonical" href={ `https://www.takedaoncologycopay.com${props.canonicalLink}` } />
    {
      props.jsonLd && <JsonLd data={ props.jsonLd } />
    }
  </MetaTags>
);

MetaComponent.propTypes = {
  title: PropTypes.string.isRequired,
  metas: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      content: PropTypes.string.isRequired,
    }).isRequired,
  ),
};

export default MetaComponent;
